import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import {
  EMAIL_CREATION_FORM_API_KEY_SEPARATE_MESSAGES,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  getEmailFormRecipientsIds,
  withEmailCopyToArchiveUsers,
} from '../../../Email'
import {
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD,
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD,
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD,
} from '../../EditBuildingAndCategoryModal'

export function createProviderMappingFromFormValues(values) {
  return (
    values?.[PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD] ?? EMPTY_LIST
  ).map(row => ({
    [PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD]:
      getItemsIds(
        row?.[
          PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD
        ] ?? EMPTY_LIST,
        'value'
      ),
    [PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD]:
      getItemsIds(
        row?.[
          PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD
        ] ?? EMPTY_LIST,
        'value'
      ),
  }))
}

// The backend rejects `copy_to_archive` together with `separate_messages`.
export function getProviderTableEmailPayload({ payload, values }) {
  return payload[EMAIL_CREATION_FORM_API_KEY_SEPARATE_MESSAGES]
    ? payload
    : withEmailCopyToArchiveUsers(
        payload,
        getEmailFormRecipientsIds(values[EMAIL_CREATION_FORM_FIELD_NAME_TO])
      )
}
